import config from "./firebaseConfig.js";
import firebase from "firebase/app";

export default firebase.initializeApp(config);